import React from 'react';
import { BackButton, NextButton } from '../../../common/buttonsComponents';
import DummyButton from '../../../tools/SearchPage/DummyButton/DummyButton';
import { useDispatch, useSelector } from 'react-redux';
import { extractSelectedInboxTab, getDecisionNodeAtPath, isSelectedTicketTaken } from '../../../../extractFromState';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import PropTypes from 'prop-types';
import { DTMacroText } from '../DTMacroText/DTMacroText';
import { ContentWrapper, ActionsButtonsWrapper } from './DTCopyText.styles';

export const DTCopyText = (props) => {
  const { buttonText, hideCopyText = false, onFreeCopy, onNextButtonClick, disableActionButton } = props;

  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const selectedTicketTaken = useSelector(isSelectedTicketTaken);
  const selectedInboxTab = useSelector(extractSelectedInboxTab);
  const dummyButtonActionTag = decisionNode.dummyButtonActionTag;

  const { isDummyActionUsed, handleDummyButtonClick } = DummyButton.useDummyButton({ dummyButtonActionTag });

  const handleBackButtonClick = () => {
    dispatch(returnToPreviousMacroWizardPath());
  };

  const isNextButtonActive = !disableActionButton && selectedTicketTaken && isDummyActionUsed();

  return (
    <>
      <ContentWrapper>
        {!hideCopyText && <DTMacroText disableManualCopy={!isNextButtonActive} onFreeCopy={onFreeCopy} />}
      </ContentWrapper>
      <ActionsButtonsWrapper>
        <NextButton
          id="copyTextNextButton"
          active={isNextButtonActive}
          disabled={!isNextButtonActive}
          onClick={onNextButtonClick}
        >
          {buttonText}
        </NextButton>
        <DummyButton
          buttonData={dummyButtonActionTag}
          decisionFlow={true}
          onClick={handleDummyButtonClick}
          selectedInboxTab={selectedInboxTab}
        />
        <BackButton onClick={handleBackButtonClick}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </>
  );
};

DTCopyText.propTypes = {
  buttonText: PropTypes.string.isRequired,
  hideCopyText: PropTypes.bool,
  onNextButtonClick: PropTypes.func.isRequired,
  onFreeCopy: PropTypes.func,
  disableActionButton: PropTypes.bool,
};
